import React, { useState } from 'react'
import { TimePicker, Select, Form, DatePicker } from "antd"
import { PlusCircleOutlined } from '@ant-design/icons'
import './index.scss'

const quarterDayNum = []
for ( var i = 1; i<= 90;i++ ){
  quarterDayNum.push(i)
}



export default (props) => {
  const [ dayNum ] = useState([1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28])
  const [ week,setweek ] = useState(false)
  const [ month,setmonth ] = useState(false)
  const [ day,setday ] = useState(false)
  const [ date,setdate ] = useState(false)
  const [ quarter,setquarter ] = useState(false)
  const [ countTime, setCountTime ] = useState([1])

  const changCycle = (e) => {
    setweek(false)
    setmonth(false)
    setday(false)
    setdate(false)
    setquarter(false)
    eval(`set${e}(true)`)
  }

  const addCircle = (e) => {
    const len = countTime.length
    setCountTime([...countTime,len+1])
  }

  return (
    <div className='choose-cycle'>
      <Form.Item label="周期" name="period" rules={[{ required: true, message: '请选择缺周期' }]}>
        <Select allowClear placeholder="请选择" onChange={changCycle}>
          { props.showList.day && <Select.Option value='day'>天</Select.Option>}
          { props.showList.week &&  <Select.Option value='week'>周</Select.Option>}
          { props.showList.month &&  <Select.Option value='month'>月</Select.Option>}
          { props.showList.quarter &&  <Select.Option value='quarter'>季度</Select.Option>}
          { props.showList.date &&  <Select.Option value='date'>指定日期</Select.Option>}
        </Select>
      </Form.Item>
      {date &&
      <Form.Item
        label='巡检日期'
        name='dateday'
        rules={[{ required: true, message: '请选择巡检日期!' }]}
      >
        <DatePicker />
      </Form.Item>
      }
      { week &&
      <Form.Item
        label='巡检日'
        name='weekDay'
        rules={[{ required: true, message: '请选择巡检日!' }]}
      >
        <Select allowClear placeholder="请选择">
          <Select.Option value={1}>星期一</Select.Option>
          <Select.Option value={2}>星期二</Select.Option>
          <Select.Option value={3}>星期三</Select.Option>
          <Select.Option value={4}>星期四</Select.Option>
          <Select.Option value={5}>星期五</Select.Option>
          <Select.Option value={6}>星期六</Select.Option>
          <Select.Option value={7}>星期天</Select.Option>
        </Select>
      </Form.Item>
      }
      { quarter && 
        <>
          <Form.Item
            label='第几月'
            name='month'
            rules={[{ required: true, message: '请选择第几月!' }]}
          >
            <Select allowClear placeholder="请选择">
              <Select.Option value={1}>1</Select.Option>
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label='第几天'
            name='day'
            rules={[{ required: true, message: '请选择第几天!' }]}
          >
            <Select allowClear placeholder="请选择">
              {
                dayNum.map(item => {
                  return <Select.Option key={item} value={item}>{item}</Select.Option>
                })
              }
            </Select>
          </Form.Item>
        </>
      }
      { month && 
        <Form.Item
        label='第几天'
        name='day'
        rules={[{ required: true, message: '请选择第几天!' }]}
      >
        <Select allowClear placeholder="请选择">
          {
            dayNum.map(item => {
              return <Select.Option key={item} value={item}>{item}</Select.Option>
            })
          }
        </Select>
      </Form.Item>
      }
      { day &&
        <div className='timeCircle'>
          { 
            countTime.map(item => {
              return (
                <Form.Item
                  label='时间段'
                  name={'time'+item}
                  key={item}
                  rules={[{ required: true, message: '请选择缺时间段' }]}
                >
                  <TimePicker.RangePicker style={{ marginBottom: '5px' }} />
                </Form.Item>
              )
            })
          }
          {/* <PlusCircleOutlined className='add-icon' onClick={addCircle} /> */}
        </div>
      }
    </div>
  )
}